import { render, staticRenderFns } from "./NovoChecklist.vue?vue&type=template&id=8aae135a&scoped=true&"
import script from "./NovoChecklist.vue?vue&type=script&lang=js&"
export * from "./NovoChecklist.vue?vue&type=script&lang=js&"
import style0 from "./NovoChecklist.vue?vue&type=style&index=0&id=8aae135a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aae135a",
  null
  
)

export default component.exports